module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-003"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "role": "doc-pagebreak",
      "title": "13"
    }
  }), _c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("W")]), _vm._v("e are deeply aware that this book comes out of long years in dialogue and community with many friends and partners. We stand on the shoulders of many who have gone before us. We wish we could name and honor you all. Hopefully, many of you will see yourselves on the following pages, and know we are deeply grateful.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This book would never have seen the light of day without the belief in us that our editors at IVP have shown. To Cindy Bunch, Ruth Goring and Bob Fryling: Thanks! Cindy and Ruth, your editorial expertise made this book so much better. Thanks to Jim Bell for his helpful suggestions on the title. Thanks also to Ruth Haley Barton, who has held this book in her heart and prayerfully journeyed with us the whole way.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Words cannot express our love and appreciation for the many partners in InterVarsity Christian Fellowship who have worked with us, wept with us and worshiped with us as together we sought God’s "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "role": "doc-pagebreak",
      "title": "14"
    }
  }), _vm._v("multiethnic kingdom of justice and love. Thanks too to the Urbana leadership team for inviting us to minister our insights at Urbana Convention seminars and sessions.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("And thanks to J. Derek, Omari and Mia McNeil and MaryKay, Chris, Steve and Colby Richardson for your support and suggestions. Without your love and belief in us, and without your partnership in the racial justice journey, this book, and the convictions and ministries that lie behind it, would never have been possible.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c31fa91e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/pre4.vue
// module id = 72
// module chunks = 0